import { Link, } from 'react-router-dom';
import {
    Box,
    Typography,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import SchoolIcon from '@mui/icons-material/School';
import CreateIcon from '@mui/icons-material/Create';

const Mode = ({ document, filteredTerms, sx = [], ...props }) => {
    const numTerms = document.terms.length;
    const numTermsFav = document.terms.filter((term) => term.fav).length;
    const numTermsCorrectAnswers = document.terms.filter((term) => term.writeCardsResults?.correctAnswer).length;
    const numTermsFavCorrectAnswers = document.terms.filter((term) => term.writeCardsResults?.correctAnswer && term.fav).length;
    const termsTypeLearningCards = document.modes.learningCards.termsType;
    const termsTypeWriteCards = document.modes.writeCards.termsType;
    const progressLearningCards = document.modes.learningCards.progress;

    const getPercentProgressLearningCards = (progress, numTerms) => {
        if (progress === 0) {
            return 0;
        }

        return (((progress + 1) / numTerms) * 100).toFixed(0);
    };

    const getPercentProgressWriteCards = (numTermsCorrectAnswers, numTerms) => {
        if (numTermsCorrectAnswers === 0) {
            return 0;
        }

        return ((numTermsCorrectAnswers / numTerms) * 100).toFixed(0);
    };

    const progressPercentLearningCards = (termsTypeLearningCards === 'all')
        ? getPercentProgressLearningCards(progressLearningCards, numTerms)
        : getPercentProgressLearningCards(progressLearningCards, numTermsFav);

    const progressPercentWriteCards = (termsTypeWriteCards === 'all')
        ? getPercentProgressWriteCards(numTermsCorrectAnswers, numTerms)
        : getPercentProgressWriteCards(numTermsFavCorrectAnswers, numTermsFav);

    return (
        <Box
            {...props}
            sx={[
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}>
            <Typography
                component='h4'
                variant='h5'
                sx={{
                    fontSize: [16, 19, 22, 25],
                    mb: 3,
                }}>Режим обучения</Typography>
            <Grid
                container
                alignItems='center'
                sx={{
                    bgcolor: (theme) => theme.palette.mode === 'light' ? 'common.white' : 'common.rhino',
                    border: 1,
                    borderColor: (theme) => theme.palette.mode === 'light' ? 'borderColor.main' : 'common.pattensBlue',
                    borderLeftWidth: [10, 15, 17, 20],
                    py: 3.5,
                    pr: [3, 4, 3.5, 3.5],
                    pl: [3, 4, 2],
                }}>
                <Grid item container alignItems='center' xs={12} md={6} sx={{ mb: [3.5, 4, 0], pr: { md: 2 }, }}>
                    <Grid
                        item xs={12}
                        md={3}
                        lg={2}
                        sx={{
                            mb: [1, 2, 0],
                            pl: {
                                md: 1,
                            },
                            textAlign: ['center', 'center', 'left'],
                        }}>
                        <SchoolIcon sx={{ color: 'text.primary', fontSize: [50, 60], }} />
                    </Grid>
                    <Grid item xs={12} md={9} lg={10}>
                        <Typography sx={{ color: 'text.primary', fontSize: [16, 17, 18, 20], fontStyle: 'italic', }}>Выберите подходящий вам режим обучения. Учите новые слова, работайте над орфографией.</Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6} sx={{ pl: { md: 2 }, }}>
                    <List aria-label='mode' sx={{
                        p: 0,
                        '& .MuiListItem-root': {
                            bgcolor: (theme) => theme.palette.mode === 'light'
                                ? 'grey.200' : 'common.kashmirBlue',
                            border: 1,
                            borderColor: (theme) => theme.palette.mode === 'light' ? 'borderColor.main' : 'common.pattensBlue',
                            p: 0,
                            '&:hover': {
                                borderColor: 'secondary.main',
                                '& .MuiListItemText-primary, & .MuiSvgIcon-root': {
                                    color: 'secondary.main',
                                },
                            },
                            '& .MuiListItemButton-root': {
                                p: [1, 1.5, 2, 2.5],
                                '& .MuiListItemText-root': {
                                    color: 'text.primary',
                                    '& .MuiListItemText-primary': {
                                        fontSize: [15, 16, 17, 18],
                                        fontWeight: 500,
                                        mb: 0.5,
                                        textDecoration: 'underline',
                                    },
                                    '& .MuiListItemText-secondary': {
                                        color: 'text.primary',
                                        fontSize: 13,
                                        fontStyle: 'italic',
                                        lineHeight: 1.5,
                                    },
                                },
                                '& .MuiListItemIcon-root': {
                                    minWidth: 'auto',
                                    mr: [1, 1.5, 2, 2.5],
                                    '& .MuiSvgIcon-root': {
                                        fontSize: 28,
                                    },
                                },
                            },
                        },
                    }}>
                        <ListItem disablePadding sx={{ mb: 1.5, }}>
                            <ListItemButton component={Link} to={`/set/${document.id}/learning-cards`}>
                                <ListItemIcon>
                                    <AutorenewIcon />
                                </ListItemIcon>
                                <ListItemText primary='Перейти к режиму «Карточки»' secondary={`Последний режим: ${termsTypeLearningCards === 'all' ? '«Все»' : '«Только избранные»'}. Прогресс: ${progressPercentLearningCards}%`} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component={Link} to={`/set/${document.id}/write-cards`}>
                                <ListItemIcon>
                                    <CreateIcon />
                                </ListItemIcon>
                                <ListItemText primary='Перейти к режиму «Орфография»' secondary={`Последний режим: ${termsTypeWriteCards === 'all' ? '«Все»' : '«Только избранные»'}. Изучено: ${progressPercentWriteCards}%`} />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Mode;